/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationSummariesControllerFindOneQueryResponse, ApplicationSummariesControllerFindOnePathParams, ApplicationSummariesControllerFindOneQueryParams, ApplicationSummariesControllerFindOne400, ApplicationSummariesControllerFindOne401, ApplicationSummariesControllerFindOne403, ApplicationSummariesControllerFindOne404 } from "../../models/checklistsController/ApplicationSummariesControllerFindOne";

function getApplicationSummariesControllerFindOneUrl(id: ApplicationSummariesControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/checklist-application-summaries/${id}` as const }  
  return res
}

/**
 * @summary Get a specific checklist application summary by ID
 * {@link /api/v1/checklist-application-summaries/:id}
 */
export async function applicationSummariesControllerFindOne(id: ApplicationSummariesControllerFindOnePathParams["id"], params?: ApplicationSummariesControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ApplicationSummariesControllerFindOneQueryResponse, ResponseErrorConfig<ApplicationSummariesControllerFindOne400 | ApplicationSummariesControllerFindOne401 | ApplicationSummariesControllerFindOne403 | ApplicationSummariesControllerFindOne404>, unknown>({ method : "GET", url : getApplicationSummariesControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}